"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import l from "../components/Icon/SvgIcon.js";
const h = (c) => /* @__PURE__ */ o(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...c,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.745 18.732c2.07 0 3.755-1.385 3.755-3.086V9.823c0-1.701-1.685-3.085-3.755-3.085h-5.74c-2.07 0-3.755 1.384-3.755 3.085v5.823c0 1.701 1.685 3.086 3.755 3.086zM10.24 20.75h3.27c1.48 0 2.058-.214 2.275-.865a5.7 5.7 0 0 1-1.04.097h-5.74c-.358 0-.704-.035-1.04-.097.217.651.795.865 2.275.865m4.635-17.526L8.85 3.25l.025 2.25q.03 0 .061-.006l.069-.006h3.47l2.4-.01zm1.232 2.377-.015.066c2.103.513 3.658 2.172 3.658 4.156v5.823c0 1.644-1.073 3.06-2.634 3.795C16.898 21.536 15.568 22 13.51 22h-3.27c-2.058 0-3.388-.464-3.606-2.559C5.073 18.706 4 17.29 4 15.646V9.823C4 7.839 5.555 6.18 7.658 5.667q-.006-.034-.015-.066a.4.4 0 0 1-.018-.099V3.224C7.625 2.549 8.175 2 8.85 2h6.05c.675 0 1.225.549 1.225 1.224v2.278c0 .035-.009.067-.018.099m-5.337-.737h2.21a.5.5 0 0 0 0-1h-2.21a.5.5 0 0 0 0 1m-1.364 7.213c-1.12 2.257-.392 3.75 1.457 4.745-.817-1.901.018-3.11 1.013-4.23-.71 2.737.587 3.092 1.031 1.6.835.71.692 1.635.142 2.63 1.741-1.066 2.452-2.506 1.172-5.1-.071.085-.133.183-.196.28-.169.263-.336.523-.675.537-.454.014-.396-.482-.32-1.143.123-1.047.293-2.51-1.438-3.033.291.681-.133 1.254-.624 1.916-.559.753-1.203 1.623-.976 2.9-.427-.142-.586-.551-.586-1.102",
        clipRule: "evenodd"
      }
    )
  }
), n = e(h);
export {
  n as Propane,
  n as default
};
